import { Person } from "#classes/Person"
import { UserRole } from "#customTypes/composedTypes/authTypes"
import {
  type StaffTitle,
  type UserConstructor,
  type UserForTable,
} from "#customTypes/composedTypes/userTypes"
import { type Uuid } from "#customTypes/globalTypes"
import { type Address, type Attendance } from "#customTypes/types"
import { camelToWords } from "#utils/textFormatters"

export class User extends Person {
  id: Uuid
  role: UserRole
  name: string
  title?: StaffTitle
  firstName: string
  lastName: string
  dob: string
  pinHash?: string
  avatar: string
  gender: string
  personalPhone: string
  personalEmail: string
  primaryAddress: Address
  teacherAttendance?: Attendance
  notes?: string
  tags?: string[]
  allergies?: string[]

  constructor(props: UserConstructor) {
    super(props)
    this.id = props.id
    this.role = props.role
    this.name = props.name
    this.title = props.title
    this.firstName = props.firstName
    this.lastName = props.lastName
    this.dob = props.dob
    this.pinHash = props.pinHash
    this.avatar = props.avatar
    this.gender = props.gender
    this.personalPhone = props.personalPhone
    this.personalEmail = props.personalEmail
    this.primaryAddress = props.primaryAddress
    // Normalize Firestore's explicit null to undefined
    this.teacherAttendance = props.teacherAttendance ?? undefined
    this.notes = props.notes
    this.tags = props.tags
    this.allergies = props.allergies
  }

  getUserForTable = (): UserForTable => ({
    id: this.id,
    role: camelToWords(this.role),
    name: this.name,
    firstName: this.firstName,
    lastName: this.lastName,
    hasPin: !!this.pinHash ? "✓" : "❌",
    dob: this.dob,
    avatar: this.avatar,
    gender: this.gender,
    phone: this.personalPhone,
    email: this.personalEmail,
    address: this.getFormattedAddress(),
    notes: this.notes ?? "",
    tags: this.getTagsAsText(),
    allergies: this.getAllergiesAsText(),
  })
}

export type Users = Record<Uuid, User>
